/**
 * Константы для работы с праздниками и выходными днями России
 */

/**
 * Государственные праздники и выходные дни России на 2024 год
 * Источник: Постановление Правительства РФ "О переносе выходных дней в 2024 году"
 */
export const HOLIDAYS_RUSSIA_2024 = [
    // Новогодние праздники
    '2024-01-01', // Новый год
    '2024-01-02', // Новогодние каникулы
    '2024-01-03', // Новогодние каникулы
    '2024-01-04', // Новогодние каникулы
    '2024-01-05', // Новогодние каникулы
    '2024-01-06', // Новогодние каникулы
    '2024-01-07', // Рождество Христово
    '2024-01-08', // Перенесенный выходной
  
    // День защитника Отечества
    '2024-02-23', // День защитника Отечества
    '2024-02-24', // Перенесенный выходной
  
    // Международный женский день
    '2024-03-08', // Международный женский день
    '2024-03-09', // Перенесенный выходной
    '2024-03-10', // Перенесенный выходной
  
    // Праздник Весны и Труда
    '2024-04-29', // Перенесенный выходной
    '2024-04-30', // Перенесенный выходной
    '2024-05-01', // Праздник Весны и Труда
    '2024-05-02', // Перенесенный выходной
    '2024-05-03', // Перенесенный выходной
  
    // День Победы
    '2024-05-09', // День Победы
    '2024-05-10', // Перенесенный выходной
    '2024-05-11', // Перенесенный выходной
    '2024-05-12', // Перенесенный выходной
  
    // День России
    '2024-06-12', // День России
  
    // День народного единства
    '2024-11-04', // День народного единства
  ];
  
  /**
   * Государственные праздники и выходные дни России на 2023 год
   */
  export const HOLIDAYS_RUSSIA_2023 = [
    // Новогодние праздники
    '2023-01-01', // Новый год
    '2023-01-02', // Новогодние каникулы
    '2023-01-03', // Новогодние каникулы
    '2023-01-04', // Новогодние каникулы
    '2023-01-05', // Новогодние каникулы
    '2023-01-06', // Новогодние каникулы
    '2023-01-07', // Рождество Христово
    '2023-01-08', // Новогодние каникулы
  
    // День защитника Отечества
    '2023-02-23', // День защитника Отечества
    '2023-02-24', // Перенесенный выходной
  
    // Международный женский день
    '2023-03-08', // Международный женский день
  
    // Праздник Весны и Труда
    '2023-05-01', // Праздник Весны и Труда
  
    // День Победы
    '2023-05-08', // Перенесенный выходной
    '2023-05-09', // День Победы
  
    // День России
    '2023-06-12', // День России
  
    // День народного единства
    '2023-11-04', // День народного единства
    '2023-11-06', // Перенесенный выходной
  ];
  
  /**
   * Государственные праздники и выходные дни России на 2025 год
   * Примечание: предварительный список, может быть изменен Постановлением Правительства РФ
   */
  export const HOLIDAYS_RUSSIA_2025 = [
    // Новогодние праздники
    '2025-01-01', // Новый год
    '2025-01-02', // Новогодние каникулы
    '2025-01-03', // Новогодние каникулы
    '2025-01-04', // Новогодние каникулы
    '2025-01-05', // Новогодние каникулы
    '2025-01-06', // Новогодние каникулы
    '2025-01-07', // Рождество Христово
    '2025-01-08', // Новогодние каникулы
  
    // День защитника Отечества
    '2025-02-23', // День защитника Отечества
    '2025-02-24', // Перенесенный выходной
  
    // Международный женский день
    '2025-03-08', // Международный женский день
    '2025-03-10', // Перенесенный выходной
  
    // Праздник Весны и Труда
    '2025-05-01', // Праздник Весны и Труда
    '2025-05-02', // Перенесенный выходной
  
    // День Победы
    '2025-05-09', // День Победы
    '2025-05-12', // Перенесенный выходной
  
    // День России
    '2025-06-12', // День России
    '2025-06-13', // Перенесенный выходной
  
    // День народного единства
    '2025-11-04', // День народного единства
  ];
  
  /**
   * Функция для проверки, является ли дата праздничным или выходным днем в России
   * 
   * @param {Date|string} date - Дата для проверки
   * @param {number} year - Опционально, год для проверки (по умолчанию текущий)
   * @returns {boolean} true, если дата является выходным или праздничным днем
   */
  export const isHolidayInRussia = (date, year = new Date().getFullYear()) => {
    const dateStr = typeof date === 'string' ? date : date.toISOString().split('T')[0];
    
    // Выбираем список праздников в зависимости от года
    let holidayList;
    switch (year) {
      case 2023:
        holidayList = HOLIDAYS_RUSSIA_2023;
        break;
      case 2024:
        holidayList = HOLIDAYS_RUSSIA_2024;
        break;
      case 2025:
        holidayList = HOLIDAYS_RUSSIA_2025;
        break;
      default:
        holidayList = HOLIDAYS_RUSSIA_2024; // По умолчанию используем 2024 год
    }
    
    // Проверяем, есть ли дата в списке праздников
    if (holidayList.includes(dateStr)) {
      return true;
    }
    
    // Проверяем, является ли день выходным (суббота или воскресенье)
    const dayOfWeek = new Date(dateStr).getDay();
    return dayOfWeek === 0 || dayOfWeek === 6; // 0 - воскресенье, 6 - суббота
  };
  
  /**
   * Получение всех праздничных и выходных дней в указанном диапазоне
   * 
   * @param {Date|string} startDate - Начальная дата диапазона
   * @param {Date|string} endDate - Конечная дата диапазона
   * @returns {Array} Массив дат (строк в формате YYYY-MM-DD), которые являются выходными или праздниками
   */
  export const getHolidaysInRange = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const holidays = [];
    
    // Убедимся, что даты в правильном порядке
    if (start > end) {
      return getHolidaysInRange(endDate, startDate);
    }
    
    const currentDate = new Date(start);
    while (currentDate <= end) {
      const dateStr = currentDate.toISOString().split('T')[0];
      const year = currentDate.getFullYear();
      
      if (isHolidayInRussia(dateStr, year)) {
        holidays.push(dateStr);
      }
      
      currentDate.setDate(currentDate.getDate() + 1);
    }
    
    return holidays;
  };
  
  /**
   * Получение списка праздников по году
   * 
   * @param {number} year - Год (по умолчанию текущий)
   * @returns {Array} Список праздников для указанного года
   */
  export const getHolidaysByYear = (year = new Date().getFullYear()) => {
    switch (year) {
      case 2023:
        return HOLIDAYS_RUSSIA_2023;
      case 2024:
        return HOLIDAYS_RUSSIA_2024;
      case 2025:
        return HOLIDAYS_RUSSIA_2025;
      default:
        return HOLIDAYS_RUSSIA_2024;
    }
  };